"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
require("../checkbox/index.tsx");
//@ts-ignore
require("../theme.ts");
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // static propTypes = {
        // 	dataSource: Object,
        // 	columns: Object
        // }
        _this.removeItem = function (item) {
            _this.props.dataSource.splice(_this.props.dataSource.indexOf(item), 1);
            _this.update();
        };
        _this._changeHandlerTh = function (e, item) {
            _this.fire('changeall', { item: item, checked: e.detail });
            _this.props.dataSource.forEach(function (item) {
                item.checked = e.detail;
            });
            _this.update();
        };
        _this._changeHandlerTd = function (e, item) {
            _this.fire('change', { item: item, checked: e.detail });
            item.checked = e.detail;
            _this.update();
        };
        return _this;
    }
    Table.prototype.beforeRender = function () {
        if (this.dataSource) {
            this.props.dataSource = this.dataSource;
        }
        if (this.columns) {
            this.props.columns = this.columns;
        }
        if (this.hasOwnProperty('checkbox')) {
            this.props.checkbox = this.checkbox;
        }
    };
    Table.prototype._getCheckedState = function () {
        var c = 0, uc = 0;
        for (var i = 0, len = this.props.dataSource.length; i < len; i++) {
            if (this.props.dataSource[i].checked) {
                c++;
            }
            else {
                uc++;
            }
            if (c > 0 && uc > 0) {
                return { 'indeterminate': true };
            }
        }
        if (c === 0)
            return { 'unchecked': true };
        return { 'checked': true };
    };
    Table.prototype.render = function (props) {
        var _this = this;
        if (!props.columns)
            return;
        if (!props.dataSource)
            return;
        return (omi_1.h("table", __assign({}, omi_1.extractClass(props, 'm-table', {
            'm-table-checkbox': props.checkbox
        })),
            omi_1.h("thead", null,
                omi_1.h("tr", null, props.columns.map(function (item, index) {
                    var obj = {};
                    var width = item.width;
                    if (width !== undefined) {
                        obj.style = { width: typeof width === 'number' ? width + 'px' : width };
                    }
                    return omi_1.h("th", __assign({}, obj, { class: "text-left" }),
                        index === 0 && props.checkbox && omi_1.h("m-checkbox", __assign({}, _this._getCheckedState(), { onChange: function (_) { return _this._changeHandlerTh(_, item); } })),
                        item.title);
                }))),
            omi_1.h("tbody", { class: "table-hover" }, props.dataSource.map(function (item) { return (omi_1.h("tr", null, props.columns.map(function (subItem, subIndex) {
                var obj = {};
                var width = subItem.width;
                if (width !== undefined) {
                    obj.style = { width: typeof width === 'number' ? width + 'px' : width };
                }
                return omi_1.h("td", __assign({}, obj, { class: "text-left" }),
                    subIndex === 0 && props.checkbox && omi_1.h("m-checkbox", { checked: item.checked, onChange: function (_) { return _this._changeHandlerTd(_, item); } }),
                    subItem.render ? subItem.render(item) : item[subItem.key]);
            }))); }))));
    };
    Table.css = css;
    Table = __decorate([
        omi_1.tag('m-table')
    ], Table);
    return Table;
}(omi_1.WeElement));
exports.default = Table;
